module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.scale-border {\r\n    padding: 15px;\r\n    border: 1px solid gray;\r\n    margin-top: 4px;\r\n}\r\n\r\n.rowmargin{\r\n   margin:  -15px -15px 10px -15px\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/scales/scales-form/scales-form.component.css
// module id = ./src/app/master/scales/scales-form/scales-form.component.css
// module chunks = main